var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-text preview"},[_c('div',{style:({ verticalAlign: _vm.element.style.verticalAlign })},[_vm._v(" "+_vm._s(_vm.element.style.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }